import { LocaleMessages } from 'vue-i18n';

export class BrandingInfo {
  public CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL: string = '';
  public WL_REFERRAL_MESSAGE_TO_REFERRED_FRIEND_SUBJECT: string = '';
  public companycode: string = '';
  public WL_NOTIFICATION_PREFERENCES:string=''
  public SUPPORT_EMAIL: string = '';
  // tslint:disable-next-line:variable-name
  public CANDIDATE_PORTAL_LEARN_MORE_END_POINT_URL: string = '';
  public CANDIDATE_PORTAL_CONTEXT_URL: string = '';
  public CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL: string = '';
  public RECAPTCHA_CLIENT_SITE_KEY: string = '';
  public CANDIDATE_PORTAL_LOGO_URL!: string;
  public DROPBOX_APP_KEY!: string;
  public WL_CANDIDATE_PORTAL_TITLE!: string;
  public WL_CANDIDATE_PORTAL_WELCOME_SCREEN_TITLE!: string;
  public CANDIDATE_PORTAL_LOGO_SPINER_URL!: string;
  public WL_CANDIDATE_PORTAL_APPLICATION_NAME!: string;
  public CONTEXT_URL_COMPANY_LOGO_URL_ALIAS!: string;
  public COMPANY_COUNTRY_CODE!: string;
  public COMPANY_DISTANCE_UNIT!: string;
  public COMPANY_RADIUS_MAX!: string;
  public COMPANY_RADIUS_MIN!: string;
  public COMPANY_DATE_FORMAT!: string;
  public WL_COMPANY_TAG_LINE: string = '';
  public CURRENCY: string = '';
  //Social Media Login creds
  public FACEBOOK_CLIENT_ID: string = '';
  public FACEBOOK_CLIENT_SECRET: string = '';
  public FACEBOOK_USER_AUTHORIZATION_URI: string = '';
  public FACEBOOK_SCOPE: string = '';

  public GOOGLE_CLIENT_ID: string = '';
  public TURN_OFF_GOOGLE_CONTACTS: boolean = false;
  public GOOGLE_CLIENT_SECRET: string = '';
  public GOOGLE_USER_AUTHORIZATION_URI: string = '';
  public GOOGLE_SCOPE: string = '';
  public GOOGLE_CONTACT_SCOPE: string = '';

  public LINKEDIN_CLIENT_ID: string = '';
  public LINKEDIN_CLIENT_SECRET: string = '';
  public LINKEDIN_USER_AUTHORIZATION_URI: string = '';
  public LINKEDIN_SCOPE: string = '';

  public WL_RESUME_UPLOAD_REQUIRED: string = '';
  public ALLOWED_RESUME_FORMATS: string = '';
  public PRE_ESTABLISHED_REDIRECT_URI: string = '';

  public DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN: string = '';
  public myJobTabs: any;
  public leftMenu: any;
  public REFERFRIEND_AFTER_LOGIN_ONLY: string = '';
  public SHOW_REFERRAL_INCENTIVE: boolean = true;
  public ZERO_INCENTIVE_ENABLED: boolean = true;
  public EXTERNAL_TIMESHEETS: boolean = true;
  public WL_DROPBOX_INTEGRATION_ENABLED: String = 'true';
  public REFER_A_FRIEND_TITLE: string = '';
  public REFER_A_FRIEND_TITLE_FR: string = '';
  public adduserjobhistory: boolean = true;
  public NEGOTIABLE_JOB_TEXT: string = '';
  public DISABLE_REFERRAL_BONUS_INFO_IN_REFERRAL_PAGE: string = 'false';
  public SHOW_SURVEY_MESSAGE: boolean = true;
  public SHOW_GUIDED_SIGNUP: boolean = false;
  public LANDING_PAGE_AFTER_SIGN_IN: string = 'FIND_JOBS';
  public LANDING_PAGE_BEFORE_SIGN_IN: string = 'FIND_JOBS';
  
  public HOME_PAGE_FORUM_COMING_SOON_MSG: string = '';
  public HOME_PAGE_STATIC_MSG: string = '';
  public HOME_PAGE_STATIC_HEADER: string = '';

  public GUIDED_SIGNUP_STEPS: Array<string> = [];
  public CONTINUE_SCREEN_INDEX: number = 0;
  public SHOW_APPLICATION_LINK_IN_FIND_JOBS: boolean = false;
  public HOME_PAGE_CARDS: Array<any> = [];
  public SHOW_SKILL_ADVANCED_OPTIONS: boolean = false;
  public ENABLE_USER_PROFILE_V2: boolean = false;
  public ENABLE_MAP_VIEW_IN_FINDJOBS: boolean = false;
  public SKILL_DOCUMENT_LICENCE_INFO: boolean = true;
  public ENABLE_FORUM_COMING_SOON: boolean = false;
  public CANDIDATE_PORTAL_UPLOAD_PROFILE_PICTURE_DISABLED: boolean = false;
  public HOME_CONTENT: any = null;
  public SUPPORT_PHONE_NUMBER: string = '';
  public STAGES_TO_SKIP_OTP_VERIFICATION: any = null;
  public CANDIDATE_PORTAL_SKILL_CHECKLIST_CERTIFY: string = '';
  public CANDIDATE_PORTAL_SKILL_CHECKLIST_AUTHORIZE: string = '';
  public CHECK_USER_PROFILE_FORUM_ENABLED_FLAG: boolean = false;
  public FORUM_COMING_SOON_HEADER: string = '';
  public AIRFRAMES: Array<string> = [];
  public ENGINE_TYPE: string[] = [];
  public LICENCE_AUTHORITY: string[] = [];
  public SHOW_TOTAL_FLIGHT_HOURS: boolean = false;
  public ENABLE_ROLEBASED_REGISTRATION: boolean = false;
  public PROFILE_ACCORDIONS: string[] = [];
  public INTERNAL_REFERRAL_ENABLED: boolean = false;
  public AUTO_POPULATE_RECRUITER_LIST: string = 'false';
  public REFER_FRIEND_BOX_BUTTON_TEXT: string = '';
  public REFER_FRIEND_BOX_BUTTON_ROUTE: string = '';
  public SOCIAL_REGISTRATION: any = {};
  public SHOW_FORUM_IN_HOME_PAGE: boolean = false;
  public CANDIDATE_PORTAL_COMPANY_LOGO_REDIRECTION_LINK: string = '';
  public JOB_HIDDEN_FIELDS: string = '';
  public WL_ENABLE_FORUM_MEDIA_CANDIDATE: string = 'false';
  public HELP_FORALL_OTHER =
    'For all other enquiries (e.g. information about jobs), please contact:';
  public SKILLS_SECTION_TITLE = 'Skills/Specialty(s)';
  public PROFESSIONAL_REFERENCE_PRIMARY_SUBHEADER: boolean = false;
  public OTHER_SUPPORT_EMAIL: string = '';
  public SHOW_CUSTOMER_BASED_TECH_SUPPORT: boolean = false;
  public OTHER_SUPPORT_PHONE_NUMBER: string = '';
  public LOCATION_JOB_FILTER_COUNTRIES: string[] = [];

  public TL_SINGLE_SUPPORT_NUMBER_PRESENT: boolean = true;
  public TL_SUPPORT_PHONE_NUMBER: string = '';
  public ENABLE_PROFESSIONAL_REFERENCE_LONG_FORM: boolean = false;
  public ENABLE_ROLE_BASED_GSU_STEPS: boolean = false;
  public ADDITIONAL_DOCUMENT_FORMATS: string = '';
  public ENABLE_CHATBOT: boolean = false;
  public WL_SIMILAR_JOB_FEATURE_ENABLED: string = 'false';
  public ENABLE_SIMILAR_JOBS_ALERT: boolean = false;
  public HEADER_HTML: string = '';
  public FOOTER_HTML: string = '';
  public ENABLE_DYNAMIC_HEADER_INJECTION: boolean = false;
  public ENABLE_DYNAMIC_FOOTER_INJECTION: boolean = false;
  public DYNAMIC_HEADER_WHEN_LOGGED_IN_ONLY: boolean = false;
  public STREET_ADDRESS: string = '';
  public ADDRESS_LOCATION: string = '';
  public ADDRESS_REGION: string = '';
  public POSTAL_CODE: string = '';
  public ADDRESS_COUNTRY: string = '';
  public IS_GDPR_ENABLED: boolean = true;
  public COMPANY_NAME: string = '';
  public SEO_LOGO_FILE: string = '';

  public ENABLE_ANONYMOUS_SAVED_JOBS: boolean = false;
  public ENABLE_APPLY_BUTTON_ON_TOP_OF_JOB_DESCRIPTION: boolean = false;

  public ENABLE_PROFESSIONAL_REFERENCE_SUB_HEADER: boolean = true;
  public USE_LOGIN_SIGNUP_V2: boolean = false;
  public TURN_ON_SIGNUP_RECAPTCHA: boolean = false;
  public HIDE_SUPPORT_NUMBER: boolean = false;
  public MIN_SPECIAL_CHARS: number = 1;
  public MIN_UPPERCASE_CHARS: number = 1;
  public MIN_PASSWORD_LENGTH: number = 8;
  public MIN_NUMBER_CHARS: number = 1;
  public HIDE_DOB_IN_PROTECTED_INFORMATION: boolean = false;
  public TURN_ON_CREDENTIALING: boolean = false;
  public HIDE_SUPPORTING_DOCUMENTS_FROM_SKILL_DETAILS: boolean = false;
  public SHOW_MY_DOCUMENTS_SECTION_IN_GUIDED_SIGNUP: boolean = false;
  public HOST_MAPPING: string = '';

  public ENABLE_JOBALERT_V2: boolean = false;

  public ADD_NOINDEX_TAG_TO_ALL_PAGES: boolean = false;

  public miscConfig: any = {};
  public SKIP_GSU_ON_REGISTRATION_FOR_USERS_ONFILE = false;
  public HIDE_EDUCATION_HISTORY_DATES = false;
  public DISABLE_MYREFERRALS_PROMOTE_TAB = false;
  public USE_ALTERNATIVE_PROFILE_WIDGET_COLOR = false;
  public GSU_AFTER_JOB_APPLY = false;
  public PHONE_NUMBER_UPDATE_TRIGGER_SMS_OTP = false;
  public QUICK_JOB_APPLY_ENABLED = false;
  public SHOW_COMPANY_NAME_LINK_IN_JOB_CARD = "false";
  public HIDE_JOB_DETAILS_IN_JOB_LIST_PAGE = false;
  public HIDE_RECRUITER_SELECTION_IN_REFER_A_FRIEND = 'false';
  public HIDE_CURRENT_PAY_FIELD_IN_WORK_PREFERENCE = false;
  public HIDE_JOB_SEARCH_STATUS_IN_WORK_PREFERENCE = false;
  public CANDIDATE_PORTAL_COMPANY_FINDJOB_REDIRECTION_LINK: string = '';
  public RETRIEVED_EMAIL_VERIFICATION_TEXT: string = '';
  public ENABLE_ESSIUM_INTEGRATION: boolean = false;
  public TALENT_PORTAL_BANNER_TEXT: string =  '';
  public TALENT_PORTAL_BANNER_TEXT_FR: string =  '';
  public WL_MULTI_FACTOR_AUTHENTICATION_ENABLED= 'false';
  public AUDIO_EYE_SITE_HASH : string =  '';
  public INTERVIEW_CODE_MANAGEMENT:boolean = false;
  public USER_SOURCE_TYPE: string = ''
  public ENABLE_WL_ANALYTICS_INTEGRATION: Boolean = false;
  public SUPPORTED_TRANSLATION_LANGUAGES: string = '';
  public WL_AUTOMATE_REFERRAL_EMAILS:boolean = false;
  public ENABLE_JOB_LOCATION_DROPDOWN:boolean = false;
  public SORT_BY_LABEL_ENABLED:boolean = false;
  public USER_TOS_AGREEMENT_TEXT: string = '';
  public USER_TOS_AGREEMENT_TEXT_FR: string = '';
  public SHOW_JOB_SHARE_SOCIAL_LINKS: boolean = false;
  public REFERRAL_ENABLED: Boolean = true;
  public HIDE_DATE_RANGE_IN_JOB_CARD: boolean = false;
  public VUE_LOCATION_AUTOCOMPLETE_TYPES: string = '';
  public DISPLAY_JOB_CATEGORY_IN_JOB_CARD: boolean = true;
  public ONBOARDING_COMPLETE_TEXT: String = '';
  public HIDE_MY_JOB_STATUS: Boolean = false;
  public OPEN_TIMESHEET_IN_NEW_TAB: Boolean = false;
  public DISABLE_APPLINK_IN_BANNER: Boolean = false;
  public SIGNUP_ADDITIONAL_CONSENT: String = "";
  public HIDE_EDUCATION_HISTORY_OVERALL_RESULT_GPA: boolean = false ;
  public HIDE_SUPERVISOR_INFO_WORK_EXPERIENCE : boolean = false;
  public HIDE_SHIFT_PREFERENCE_FIELD_IN_WORK_PREFERENCE = false;
  public HIDE_STATE_IN_PERSONAL_INFO : boolean = false;
  public DISPLAY_HEADER_FROM_CMS: boolean = false;
  public REQUIRED_FIELDS_IN_PERSONAL_INFO : Array<string> = [];
  public JOB_REDIRECTION_PROMPT:String="";
}
